import { EventEmitter, Injectable } from "@angular/core";

import { MultipleChoiceOption } from "app/lib/Task";
import { ExamService } from "./exam.service";
import { CommandsService } from "./commands.service";
import { BlocksService } from "./blocks.service";
import { BluetoothService } from "./bluetooth.service";
import { ProgDecl } from "app/xlogo-parser/ir/ast";

// #########################################################################
//
// This service is used to keep track of all information about the editor.
//
// #########################################################################

@Injectable()
export class EditorContentService {
  public editorText: string = "";
  public onEditorFocus;
  public textInDisplayNeedsChangeEmitter: EventEmitter<void> = new EventEmitter<
    void
  >();
  public textInDisplayHasChangedEmitter: EventEmitter<void> = new EventEmitter<
    void
  >();
  public editorEnabler: EventEmitter<boolean> = new EventEmitter<boolean>();

  private _parsedPrograms: Map<string, ProgDecl>;

  constructor(
    private blocks: BlocksService,
    private bluetoothService: BluetoothService
  ) {
    this.onEditorFocus = false;
  }

  public setTextOfCurrentEditorFromDisplay(val: string) {
    this.editorText = val;
    this.textInDisplayHasChangedEmitter.emit();
  }

  public setTextOfCurrentEditorProgrammatically(val: string) {
    this.editorText = val;
    this.textInDisplayNeedsChangeEmitter.emit();
  }

  public getCurrentEditorText(): string {
    return this.editorText;
  }

  public get ParsedPrograms(): Map<string, ProgDecl> {
    return this._parsedPrograms;
  }

  public set ParsedPrograms(programs: Map<string, ProgDecl>) {
    this._parsedPrograms = programs;
  }

  public prepareEditorTabContentForSaving(): string {
    return this.editorText;
  }

  //download text as file with a given fileName
  public downloadFile(filename, text) {
    var pom = document.createElement("a");
    pom.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    pom.setAttribute("download", filename);

    if (document.createEvent) {
      var event = document.createEvent("MouseEvents");
      event.initEvent("click", true, true);
      pom.dispatchEvent(event);
    } else {
      pom.click();
    }
  }

  public triggerTextChange() {
    this.textInDisplayNeedsChangeEmitter.emit();
  }

  public deleteAllEditorRelatedText() {
    this.editorText = "";
  }

  public enableEditor(): void {
    this.editorEnabler.emit(true);
  }

  public disableEditor(): void {
    this.editorEnabler.emit(false);
  }

  public setEditorTextAsFromFile(text: string) {
    //delete all editors and all texts
    this.editorText = "";

    //read input and separate it after $ and distribute it to multiple editors
    this.setTextOfCurrentEditorProgrammatically(text);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/editorcontent.service.ts